<button mat-menu-item (click)="copyToCLipboard('https://calendly.com/voy-jaleas/30min?month=2023-02')">
    <mat-icon>link</mat-icon>
    <span>Book videocall link (FREE)</span>
</button>


<button mat-menu-item (click)="copyToCLipboard('https://calendly.com/voy-jaleas/30min?month=2023-02')">
    <mat-icon>link</mat-icon>
    <span>Book videocall - 35 USD</span>
</button>